function updateCartProgress(wrapper, total) {
    if (!wrapper) return;
    const minOrder = parseFloat(wrapper.dataset.minOrder) || 0;
    const freeShipping = parseFloat(wrapper.dataset.freeShipping) || 0;

    if (total <= 0) {
        wrapper.innerHTML = '';
        return;
    }

    let html = '';

    if (minOrder > 0 && total < minOrder) {
        html += '<div class="alert alert-warning">' +
            'Минимальная сумма заказа — ' + minOrder + ' ₽. ' +
            'Добавьте товаров ещё на ' + (minOrder - total) + ' ₽.' +
            '</div>';
    }

    if (freeShipping > 0) {
        const remaining = Math.max(0, freeShipping - total);
        const progressPercent = Math.min(100, Math.round(total / freeShipping * 100));
        const progressText = remaining > 0
            ? 'До бесплатной доставки осталось ' + remaining + ' ₽'
            : 'Бесплатная доставка!';

        html += '<div class="cart-progress mb-4">' +
            '<p class="mb-1">' + progressText + '</p>' +
            '<div class="progress" style="height: 20px;">' +
            '<div class="progress-bar bg-success" role="progressbar" style="width: ' + progressPercent + '%" ' +
            'aria-valuenow="' + progressPercent + '" aria-valuemin="0" aria-valuemax="100">' + progressPercent + '%</div>' +
            '</div>' +
            '</div>';
    }

    wrapper.innerHTML = html;
}

function updateCartTotal(wrapper, totalFormatted, currency, totalValue, minOrder, checkoutUrl, shippingValue) {
    if (!wrapper) return;

    if (totalValue <= 0) {
        wrapper.innerHTML = '';
        return;
    }

    shippingValue = shippingValue || calculateShipping(totalValue);
    const totalWithShipping = totalValue + shippingValue;

    let buttonHtml;
    if (totalValue >= minOrder) {
        buttonHtml = '<a href="' + checkoutUrl + '" class="btn btn-success">Оформить заказ</a>';
    } else {
        buttonHtml = '<button type="button" class="btn btn-success" disabled ' +
            'data-toggle="tooltip" title="Минимальный заказ ' + minOrder + ' ₽">' +
            'Оформить заказ' +
            '</button>';
    }

    wrapper.innerHTML = '<div class="basket-total-price">' +
        '<span class="basket-total-value" id="cart__total-value">' + formatPrice(totalWithShipping, currency) + '</span>' +
        buttonHtml +
        '</div>';

    $(wrapper).find('[data-toggle="tooltip"]').tooltip();
}

function getCartDataFromResponse(response) {
    if (!response || !response.data) {
        return null;
    }
    const data = response.data;
    const positionTotalPrice = data.position_total_price || {};
    const totalPrice = data.total_price || {};
    return {
        totalValue: parseFloat(positionTotalPrice.price_value || 0),
        totalFormatted: positionTotalPrice.price || totalPrice.price || '0',
        currency: data.currency || '₽'
    };
}

function formatPrice(value, currency) {
    return value.toLocaleString('ru-RU') + ' ' + currency;
}

function getShippingData() {
    const wrapper = document.querySelector('.cart-progress-wrapper');
    if (!wrapper) return { shippingCost: 0, freeShipping: 0 };
    return {
        shippingCost: parseFloat(wrapper.dataset.shippingCost) || 0,
        freeShipping: parseFloat(wrapper.dataset.freeShipping) || 0,
    };
}

function calculateShipping(totalValue) {
    const { shippingCost, freeShipping } = getShippingData();
    if (freeShipping > 0 && totalValue >= freeShipping) {
        return 0;
    }
    return shippingCost;
}

function updateShippingRow(shippingValue, currency) {
    const row = document.querySelector('.basket-item--shipping');
    if (!row) return;
    const costCol = row.querySelector('.shipping-cost');
    if (shippingValue > 0) {
        row.style.display = 'flex';
        if (costCol) costCol.textContent = shippingValue + ' ' + currency;
    } else {
        row.style.display = 'none';
    }
}

function refreshCartState(response) {
    const cartData = getCartDataFromResponse(response);
    if (!cartData) return;

    const progressWrapper = document.querySelector('.cart-progress-wrapper');
    const totalWrapper = document.querySelector('.basket-total');
    const minOrder = parseFloat(progressWrapper.dataset.minOrder) || 0;
    const checkoutUrl = progressWrapper.dataset.checkoutUrl || '/shop/checkout';
    const shippingValue = calculateShipping(cartData.totalValue);

    updateCartProgress(progressWrapper, cartData.totalValue);
    updateCartTotal(totalWrapper, cartData.totalFormatted, cartData.currency, cartData.totalValue, minOrder, checkoutUrl, shippingValue);
    updateShippingRow(shippingValue, cartData.currency);
}

document.querySelectorAll('.cart__delete-btn').forEach(button => {
    button.addEventListener('click', function (e) {
        oc.progressBar.show();
        const btnDelete = e.currentTarget;
        const cart = document.querySelector('.basket-block');
        const cartItemsNumber = cart.children.length;

        oc.attachLoader.show(btnDelete);

        oc.request(e.currentTarget, 'Cart::onRemove', {
            'data': {'cart': [btnDelete.getAttribute('data-id')]},
            success: function (response) {
                if (!!response && response.status && !!response.data) {
                    refreshCartState(response);
                    updateCartLinkHeader(btnDelete);

                    if (cartItemsNumber > 2) {
                        oc.attachLoader.hide(btnDelete);
                        btnDelete.parentElement.parentElement.remove();
                    } else if (cartItemsNumber === 2) {
                        cart.remove();
                        document.querySelector('.basket-total').remove();
                        document.querySelector('.cart__empty').classList.remove('hidden');
                    }

                    oc.progressBar.hide();
                }
            }
        });
    });
});

$('.quantity').each(function () {
    const quantity = $(this),
        step = parseFloat(quantity.attr('step')) || 1,
        value = parseFloat(quantity.val());
    if (step < 1 && Number.isFinite(value)) {
        quantity.val(value.toFixed(1));
    }
});

$('.basket-num-minus, .basket-num-plus, .quantity').off('click change');

function showQuantityLimitMessage() {
    window.alert('Количество товара ограничено доступным остатком.');
}

$('.basket-num-minus').on('click', function (e) {
    const btnMinus = $(e.currentTarget),
        numInput = btnMinus.siblings('.basket-num-input'),
        step = parseFloat(numInput.attr('step')) || 1;

    let num = +numInput.val() - step;
    numInput.val(num);
    numInput.trigger('change')
});

$('.basket-num-plus').on('click', function (e) {
    const btnPlus = $(e.currentTarget),
        numInput = btnPlus.siblings('.basket-num-input'),
        step = parseFloat(numInput.attr('step')) || 1,
        max = parseFloat(numInput.attr('max'));

    let num = +numInput.val() + step;
    if (Number.isFinite(max) && num > max) {
        numInput.val(max.toFixed(step < 1 ? 1 : 0));
        showQuantityLimitMessage();
        numInput.trigger('change');
        return;
    }
    numInput.val(num);
    numInput.trigger('change')
});

$('.quantity').on('change', function (e) {

    const quantity = $(e.currentTarget);
    let num = +quantity.val(),
        min = parseFloat(quantity.attr('min')) || 1,
        max = parseFloat(quantity.attr('max')),
        step = parseFloat(quantity.attr('step')) || 1;
    if (!Number.isFinite(num) || num < min) {
        num = min;
    }
    if (Number.isFinite(max) && num > max) {
        num = max;
        showQuantityLimitMessage();
    }
    num = Math.round(num / step) * step;
    quantity.val(step < 1 ? num.toFixed(1) : String(num));


    const $quantityItem = $(e.currentTarget),
        cartItem = $quantityItem.parents('.basket-item'),
        dataPositionId = cartItem.attr('data-position-id'),
        data = {
            'cart': [
                {
                    'offer_id': cartItem.attr('data-offer-id'),
                    'quantity': $quantityItem.val()
                }
            ],
            'shipping_type_id': 1
        };

    oc.request(this, 'Cart::onUpdate', {
        data: data,
        success: function (response) {
            if (!!response && response.status && !!response.data) {
                const cartData = response.data,
                    priceData = cartData.position[dataPositionId];

                if (priceData) {
                    cartItem.find('.cart__position-price-value').html(priceData.price);
                    if (priceData.quantity !== undefined) {
                        const step = parseFloat($quantityItem.attr('step')) || 1;
                        const quantityValue = parseFloat(priceData.quantity) || 0;
                        $quantityItem.val(step < 1 ? quantityValue.toFixed(1) : String(Math.round(quantityValue)));
                    }
                }

                refreshCartState(response);
                updateCartLinkHeader(e.currentTarget);
            }
        }
    });
});
